import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function AboutSindhionismDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="about-sindhionism-dialog"
        className="bg-[#0A0A0A] border border-[#27272A] text-[#F3F3F2] max-w-2xl max-h-[85vh] overflow-y-auto"
      >
        <DialogHeader>
          <div className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#D4A373] font-body mb-2">
            About
          </div>
          <DialogTitle className="font-display text-3xl sm:text-4xl tracking-tight leading-tight text-left">
            Sindhionism
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-5 font-body text-sm sm:text-base leading-relaxed text-[#D4D4D8]">
          <p>
            Founded in 2016 by Dirven Hazari at the age of 21, Sindhionism began
            with a simple belief—that Sindhi stories deserve to be seen, heard,
            and celebrated by a new generation.
          </p>
          <p>
            What started as a digital content platform has grown into one of the
            world's leading destinations for original Sindhi entertainment,
            reaching audiences across the globe through films, web series,
            music, and digital content.
          </p>
          <p>
            With{" "}
            <span className="text-[#F3F3F2] font-semibold">Byo Cha Khape</span>,
            Sindhionism opened a new global distribution chapter for Sindhi
            cinema, taking the film from Indian multiplexes to houseful
            screenings across India, the United States, Europe, Africa, the
            UAE, and beyond. The film went on to become one of the most
            celebrated and widely watched Sindhi theatrical releases in history,
            connecting audiences around the world through a shared love for
            Sindhi storytelling.
          </p>
          <p>
            Today, Sindhionism is committed to building the future of Sindhi
            cinema by creating meaningful stories, nurturing new talent, and
            bringing original Sindhi films to audiences worldwide.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-[#27272A] text-[10px] sm:text-xs tracking-[0.2em] uppercase text-[#52525B] font-body">
          A Sindhionism Original
        </div>
      </DialogContent>
    </Dialog>
  );
}
